import React from 'react';
import ReactDOM from 'react-dom/client';
import FactorsCharter from '../factors_charter.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <main>
      <FactorsCharter />
    </main>
  </React.StrictMode>
);
